module.exports = __webpack_public_path__ + "static/cover_photo-cf45ae90d2c2f08e06851ecc0321a014.png";